import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useQueryString } from "@ugg/shared/hooks/use-query-string";
import { buildQueryParams } from "@ugg/shared/utils/url-query-params";
import { ReactComponent as SearchIcon } from "svg/search-icon.svg";

const LeaderboardSummonerInput = (props) => {
  const history = useHistory();
  const location = useLocation();
  const queryParams = useQueryString();
  const [input, setInput] = useState("");

  const onSearch = (value) => {
    const search = { ...queryParams };
    delete search.page;
    history.push({
      pathname: location.pathname,
      search: buildQueryParams({ ...search, user: value }),
    });
  };

  const onKeyPress = (e) => {
    if (e.key === "Enter") {
      onSearch(input);
    }
  };

  const onChange = (e) => {
    setInput(e.target.value);
  };

  return (
    <div className="leaderboard_summoner-input">
      <input placeholder="Search Riot ID" type="text" onKeyPress={onKeyPress} onChange={onChange} value={input} />
      <SearchIcon onClick={() => onSearch(input)} />
    </div>
  );
};

export default LeaderboardSummonerInput;
